import { useChatConversationByIdQuery } from "../../../__generated__/types-and-hooks";
import Chat from "./Chat";

export interface ChatContentProps {
  conversationId: number;
}

export default function ChatContent({ conversationId }: ChatContentProps) {
  const chatConversationQuery = useChatConversationByIdQuery({
    variables: { id: conversationId },
  });
  const convo = chatConversationQuery.data?.chat_conversation_by_id;
  if (!convo) return null;

  return <Chat entityId={convo.entityId} entityType={convo.entityType} />;
}
